import { SVGImage, Image } from "../assets/images";
import { metUrl } from "./metMainSite";

export interface FooterSocialLink {
  href: string;
  label: string;
  icon: string;
}

export interface FooterLegalLink {
  text: string;
  href: string;
  isPrivacy?: boolean;
  lang?: string;
}

export interface FooterSiriusConfig {
  href: string;
  logoSrc: string;
  logoAlt: string;
  ariaLabel: string;
  label: string;
}

export interface FooterConfig {
  newsletterHref: string;
  socialLinks: FooterSocialLink[];
  legalLinks: FooterLegalLink[];
  copyright: {
    name: string;
    address: string;
  };
  sirius: FooterSiriusConfig;
}

export const footerConfig: FooterConfig = {
  newsletterHref: metUrl("/account/email-preferences/"),

  socialLinks: [
    {
      href: "https://www.facebook.com/MetOpera/",
      label: "Follow us on Facebook",
      icon: SVGImage.Facebook,
    },
    {
      href: "https://www.instagram.com/metopera/",
      label: "Follow us on Instagram",
      icon: SVGImage.Instagram,
    },
    {
      href: "https://www.youtube.com/user/MetropolitanOpera",
      label: "Subscribe to our YouTube channel",
      icon: SVGImage.Youtube,
    },
    {
      href: "https://www.tiktok.com/@metopera",
      label: "Follow us on TikTok",
      icon: SVGImage.TikTok,
    },
  ],

  legalLinks: [
    {
      text: "Privacy Policy",
      href: metUrl("/information/privacy-policy/"),
    },
    {
      text: "Terms & Conditions",
      href: metUrl("/user-information/terms-and-conditions/"),
    },
    {
      text: "Accessibility",
      href: metUrl("/visit/accessibility/"),
    },
    {
      text: "Contact Us",
      href: metUrl("/about/contact-us/"),
    },
    {
      text: "Dining At The Met",
      href: metUrl("/visit/dining-at-the-met/"),
    },
    {
      text: "Our Digital Ads",
      href: metUrl("/user-information/privacy-policy/#ourads"),
    },
    {
      text: "日本語",
      href: metUrl("/japanese/"),
      lang: "ja",
    },
  ],

  copyright: {
    name: "The Metropolitan Opera",
    address: "30 Lincoln Center Plaza, New York, NY 10023",
  },

  sirius: {
    href: "https://www.siriusxm.com/channels/metropolitan-opera-radio",
    logoSrc: Image.Sirius,
    logoAlt: "SiriusXM",
    ariaLabel: "Listen live on SiriusXM Metropolitan Opera Radio",
    label: "Listen Live On",
  },
};
